// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.CuponesModal_boxModal__azAnt {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 85%;
  max-height: 85%;
  overflow-y: scroll;
  border-radius: 10px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
  font-size: 16px;
}

.CuponesModal_boxModal__azAnt .CuponesModal_exit__hVjX0 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
}

.CuponesModal_boxModal__azAnt .CuponesModal_exit__hVjX0 .CuponesModal_exitIcon__NsZKm {
  width: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
}

.CuponesModal_boxModal__azAnt .CuponesModal_exit__hVjX0 .CuponesModal_exitIcon__NsZKm:hover {
  transition: 0.2s;
  scale: 1.3;
  cursor: pointer;
  filter: brightness(1.6);
}

.CuponesModal_boxModal__azAnt .CuponesModal_titleModal__j38Yb {
  width: 85%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
  margin-top: 15px;
}

.CuponesModal_boxModal__azAnt .CuponesModal_titleModal__j38Yb p {
  font-size: 1.2rem;
  margin: 0;
}

.CuponesModal_boxModal__azAnt .CuponesModal_titleModal__j38Yb span {
  font-size: 1rem;
  color: #5a5a5a;
  margin: 5px 0 0;
}

.CuponesModal_boxModal__azAnt .CuponesModal_filters__uIB58 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  height: 150px;
}

.CuponesModal_boxModal__azAnt .CuponesModal_filters__uIB58 .CuponesModal_input__wLuVM {
  margin: 10px 0 10px 0;
}

.CuponesModal_boxModal__azAnt .CuponesModal_results__dP-dZ {
  padding-top: 20px;
  margin-top: 20px;
  display: flex;
  min-height: 400px;
  justify-content: center;
  align-items: flex-start;
  border-top: 1px solid rgba(128, 128, 128, 0.46);
}

.CuponesModal_boxModal__azAnt .CuponesModal_results__dP-dZ .CuponesModal_tableContainer__7rtHL {
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.CuponesModal_boxModal__azAnt .CuponesModal_results__dP-dZ .CuponesModal_selectors__3\\+Qpf {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.CuponesModal_boxModal__azAnt .CuponesModal_results__dP-dZ .CuponesModal_selectors__3\\+Qpf span {
  font-size: 1.3rem;
}

.CuponesModal_boxModal__azAnt .CuponesModal_info__Gy9B8 {
  animation: 0.5s CuponesModal_init__Ra87y;
}

@media screen and (max-width: 900px) {
  .CuponesModal_boxModal__azAnt {
    background-color: rgba(238, 238, 238, 0.95);
    transition: 0.3s;
    min-height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}

@keyframes CuponesModal_init__Ra87y {
  0% {
    opacity: 0;
    margin-left: 10px;
  }
  100% {
    opacity: 1;
    margin-left: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Remitos/Create/Steppers/Modales/Cupones/CuponesModal.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wCAAoB;AACtB;;AAEA;EACE;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  height: 85%;\n  max-height: 85%;\n  overflow-y: scroll;\n  border-radius: 10px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n  font-size: 16px;\n}\n\n.boxModal .exit {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80px;\n}\n\n.boxModal .exit .exitIcon {\n  width: 5%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.3;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  width: 85%;\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: flex-start;\n  margin-top: 15px;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.2rem;\n  margin: 0;\n}\n\n.boxModal .titleModal span {\n  font-size: 1rem;\n  color: #5a5a5a;\n  margin: 5px 0 0;\n}\n\n.boxModal .filters {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  height: 150px;\n}\n\n.boxModal .filters .input {\n  margin: 10px 0 10px 0;\n}\n\n.boxModal .results {\n  padding-top: 20px;\n  margin-top: 20px;\n  display: flex;\n  min-height: 400px;\n  justify-content: center;\n  align-items: flex-start;\n  border-top: 1px solid rgba(128, 128, 128, 0.46);\n}\n\n.boxModal .results .tableContainer {\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.boxModal .results .selectors {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.boxModal .results .selectors span {\n  font-size: 1.3rem;\n}\n\n.boxModal .info {\n  animation: 0.5s init;\n}\n\n@media screen and (max-width: 900px) {\n  .boxModal {\n    background-color: rgba(238, 238, 238, 0.95);\n    transition: 0.3s;\n    min-height: 100%;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    margin-left: 10px;\n  }\n  100% {\n    opacity: 1;\n    margin-left: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `CuponesModal_boxModal__azAnt`,
	"exit": `CuponesModal_exit__hVjX0`,
	"exitIcon": `CuponesModal_exitIcon__NsZKm`,
	"titleModal": `CuponesModal_titleModal__j38Yb`,
	"filters": `CuponesModal_filters__uIB58`,
	"input": `CuponesModal_input__wLuVM`,
	"results": `CuponesModal_results__dP-dZ`,
	"tableContainer": `CuponesModal_tableContainer__7rtHL`,
	"selectors": `CuponesModal_selectors__3+Qpf`,
	"info": `CuponesModal_info__Gy9B8`,
	"init": `CuponesModal_init__Ra87y`
};
export default ___CSS_LOADER_EXPORT___;
